import React from 'react';
import SleepScoreChart from './SleepScoreChart';
import SleepChart from './SleepChart';
import { RangeSelector, useTimeRange } from '../data/TimeRange';

// The Sleep tab. ONE range selector at the top drives every chart below it —
// the sleep-score trend and the duration/efficiency charts all read the same
// window (now the shared Data-tab range control, incl. a Custom range). No fixed
// "last night / 7-night / 30-night" readouts: the range you pick is the story.

const SleepDataView = () => {
  const { inRange, spanDays, selectorProps } = useTimeRange('1M');

  return (
    <div className="space-y-6">
      <RangeSelector {...selectorProps} />
      <SleepScoreChart inRange={inRange} spanDays={spanDays} />
      <SleepChart inRange={inRange} spanDays={spanDays} />
    </div>
  );
};

export default SleepDataView;
